const links = [
  {
    label: 'Github',
    url: 'https://github.com/Truta446'
  },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/juan_versolato/?hl=pt-br'
  },
  {
    label: 'Linkedin',
    url: 'https://www.linkedin.com/in/juan-versolato-10b238159/'
  }
]

export default links